import { Skeleton } from '@/components/ui/skeleton';

export default function ActivityDetailSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50">
      <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="hidden md:flex gap-2 mb-4">
          <Skeleton className="h-4 w-12 rounded" />
          <Skeleton className="h-4 w-4 rounded" />
          <Skeleton className="h-4 w-20 rounded" />
        </div>
        <div className="flex justify-center gap-2 mt-16 mb-6">
          <Skeleton className="h-9 w-28 rounded-full" />
        </div>
        <div className="text-center space-y-4">
          <Skeleton className="h-12 w-3/4 mx-auto rounded-lg" />
          <Skeleton className="h-8 w-1/2 mx-auto rounded-lg" />
          <div className="flex justify-center gap-3 mt-4">
            <Skeleton className="h-6 w-44 rounded" />
            <Skeleton className="h-6 w-32 rounded" />
          </div>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6">
        <Skeleton className="w-full aspect-[16/9] rounded-2xl" />
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 space-y-3">
            <Skeleton className="h-5 w-full rounded" />
            <Skeleton className="h-5 w-full rounded" />
            <Skeleton className="h-5 w-5/6 rounded" />
            <Skeleton className="h-5 w-full rounded" />
            <Skeleton className="h-5 w-4/5 rounded" />
            <Skeleton className="h-5 w-full rounded" />
          </div>
          <div className="space-y-4">
            <Skeleton className="h-52 rounded-xl" />
            <Skeleton className="h-36 rounded-xl" />
          </div>
        </div>
      </section>
    </div>
  );
}